/*
 * @Descripttion: TntdForm.Item
 * @Author: 郑泳健
 * @Date: 2023-02-22 23:25:24
 * @LastEditors: 郑泳健
 * @LastEditTime: 2023-04-06 17:46:57
 */

import React, { memo, useRef, useContext, useEffect } from 'react'
import { isEqual } from 'lodash'
import ItemComp from './ItemComp'
import { FormContext } from '../store'
import type { IFormItem, IFormContext, IChildrenCompFun } from '../interface'
import { getNames } from '../utils'

const Item: React.FC<IFormItem> = ({
  name,
  children,
  style,
  rules,
  shouldUpdate,
  initialValue,
  dependencies,
}) => {
  const { form, initialValues, updateRefs, compsRefs } = useContext<IFormContext>(FormContext)
  const ref = useRef<IChildrenCompFun>()

  useEffect(() => {
    compsRefs.current[getNames(name).join('.')] = () => {
      ref.current?.onRefresh?.()
    }
  }, [compsRefs, name])

  return (
    <ItemComp
      {...{
        form,
        initialValues,
        updateRefs,
        compsRefs,
        style,
        rules,
        name,
        ref,
        children,
        initialValue,
        shouldUpdate,
        dependencies,
      }}
    />
  )
}

export default memo(Item, (nextProps, prevProps) => {
  if (isEqual(nextProps.name, prevProps.name) && !!prevProps.name) {
    return true
  }
  return false
})
